<template>
  <div>
    <SiteHero
      image="/media/o-nas-hero.webp"
      eyebrow="O nas – Japonia Cars"
      title="Import oparty na doświadczeniu"
      lead="Działamy od ponad dekady i mamy na koncie ponad 5 000 sprowadzonych samochodów."
      scroll-to="specjalizacja"
    />

    <section id="specjalizacja" class="site_section">
      <div class="site_container site_split specialisation">
        <SiteCarousel v-reveal :slides="gallery" />

        <div v-reveal="150">
          <p class="site_eyebrow">Specjalizacja</p>
          <h2 class="specialisation_title">Czym się specjalizujemy?</h2>
          <p class="specialisation_lead">
            Specjalizujemy się w imporcie aut z Japonii, gdzie rynek wtórny oferuje pojazdy
            o niskim przebiegu i potwierdzonej historii serwisowej.
          </p>

          <div class="site_card">
            <p class="site_eyebrow site_eyebrow--accent">Limitowane wersje</p>
            <h4 class="specialisation_card_title">Dostęp do wyjątkowych egzemplarzy</h4>
            <p>
              Tamtejszy system aukcyjny opiera się na rygorystycznej ocenie stanu technicznego
              przez niezależnych inspektorów, co daje nam dostęp do egzemplarzy w wyjątkowej
              kondycji, również w wersjach limitowanych.
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="site_section site_section--paper workshop_section">
      <div class="site_container">
        <p class="site_eyebrow">Dlaczego Japonia Cars?</p>
        <h2 class="workshop_heading">Wyróżnia nas własne, profesjonalne zaplecze techniczne.</h2>

        <div class="workshop" v-reveal>
          <div class="workshop_copy">
            <p class="site_eyebrow workshop_eyebrow">Poznaj szczegóły</p>
            <h3>A co po przyjeździe auta?</h3>
            <p>
              Po przyjeździe auta wykonujemy naprawy, przeglądy, serwis, tuning oraz
              modyfikacje, obsługujemy też sportowe i pojazdy luksusowe bez przekazywania ich
              firmom zewnętrznym. W tym samym miejscu zajmujemy się ubezpieczeniami OC i AC,
              likwidacją szkód, rejestracją i dostawą.
            </p>
          </div>
          <div class="workshop_photo"></div>
        </div>
      </div>
    </section>

    <section class="site_section">
      <div class="site_container site_split process">
        <figure v-reveal>
          <img src="/media/o-nas-warsztat.webp" width="990" height="653" alt="Warsztat Japonia Cars" loading="lazy" />
        </figure>

        <div v-reveal="150">
          <p class="site_eyebrow">Krok po kroku – poznaj proces</p>
          <h2 class="process_title">Prowadzimy cały proces sprowadzenia samochodu</h2>
          <p class="process_lead">
            Prowadzimy cały proces dotyczący sprowadzenia samochodu z Japonii – wystarczą nam
            informacje przekazane w rozmowie telefonicznej z klientem.<br />
            <strong>Resztą zajmuje się nasz zespół:</strong>
          </p>

          <ul class="site_ticks">
            <li v-for="step in steps" :key="step"><CheckIcon /> {{ step }}</li>
          </ul>
        </div>
      </div>
    </section>

    <section class="site_container enquiry_wrap">
      <SiteEnquiry />
    </section>
  </div>
</template>

<script>
import pageHead from '@/mixins/pageHead'
import { pageSchema } from '@/utils/schema'
import SiteHero from '@/components/SiteHero.vue'
import SiteCarousel from '@/components/SiteCarousel.vue'
import SiteEnquiry from '@/components/SiteEnquiry.vue'
import CheckIcon from '@/components/icons/CheckIcon.vue'

export default {
  name: 'ONasPage',
  components: { SiteHero, SiteCarousel, SiteEnquiry, CheckIcon },
  mixins: [pageHead],

  pageHead: {
    title: 'O nas - Japonia Cars',
    description:
      'Japonia Cars — ponad dekada doświadczenia i ponad 5 000 samochodów sprowadzonych z Japonii.',
    schema: pageSchema({
      path: '/o-nas/',
      name: 'O nas',
      image: '/media/o-nas-warsztat.webp',
      breadcrumbs: [{ name: 'O nas' }],
      published: '2026-05-05T09:35:16+00:00',
      modified: '2026-06-08T11:58:13+00:00',
    }),
  },

  data() {
    return {
      gallery: [
        { src: '/media/o-nas-galeria-1.webp', alt: 'Samochód sprowadzony z Japonii' },
        { src: '/media/o-nas-galeria-2.webp', alt: 'Samochód sprowadzony z Japonii' },
        { src: '/media/o-nas-galeria-3.webp', alt: 'Samochód sprowadzony z Japonii' },
        { src: '/media/o-nas-galeria-4.webp', alt: 'Samochód sprowadzony z Japonii' },
        { src: '/media/o-nas-galeria-5.webp', alt: 'Samochód sprowadzony z Japonii' },
        { src: '/media/o-nas-galeria-6.webp', alt: 'Samochód sprowadzony z Japonii' },
        { src: '/media/o-nas-galeria-7.webp', alt: 'Samochód sprowadzony z Japonii' },
      ],
      steps: [
        'weryfikacja ofert aukcyjnych,',
        'licytacja',
        'transport morski,',
        'formalności w polskich urzędach.',
      ],
    }
  },
}
</script>

<style scoped>
/* The gallery is the narrower column; the copy sits next to it. */
.specialisation,
.process {
  grid-template-columns: 572fr 706fr;
}

.specialisation_title,
.process_title {
  margin: 15px 0 22.5px;
}

.specialisation_lead,
.process_lead {
  margin-bottom: 32px;
}

.specialisation_card_title {
  margin: 15px 0 11px;
}

/* --------------------------------------------------------- workshop --- */

.workshop_section {
  padding-bottom: 80px;
}

.workshop_heading {
  margin: 15px 0 48px;
}

.workshop {
  display: grid;
  grid-template-columns: 804fr 418fr;
  gap: 64px;
  border-radius: var(--radius);
  background: var(--ink);
  color: var(--ink-invert-soft);
  overflow: hidden;
}

.workshop_copy {
  padding: 32px 0 32px 56px;
}

.workshop_copy h3 {
  margin: 15px 0 18.5px;
  font-size: 37px;
  color: var(--ink-invert);
}

.workshop_eyebrow {
  color: var(--ink-invert-soft);
}

.workshop_eyebrow::before {
  background: var(--accent);
}

.workshop_photo {
  min-height: 250px;
  background: url('/media/o-nas-serwis.webp') center / cover no-repeat;
}

/* ---------------------------------------------------------- process --- */

.process figure img {
  width: 100%;
  border-radius: var(--radius);
  object-fit: cover;
}

.enquiry_wrap {
  padding-bottom: 80px;
}

@media (max-width: 1024px) {
  .specialisation,
  .process,
  .workshop {
    grid-template-columns: 1fr;
    gap: 0;
  }

  .workshop_copy {
    padding: 32px;
  }
}
</style>
